// Single source of truth for motion timing. The CSS custom properties
// (--motion-fast/base/slow, --ease-standard) are generated from these values in
// styles.ts, and the globe client reads the same numbers, so animation timing
// stays in sync between the stylesheet and JS-driven transitions.

/** Transition/animation durations in milliseconds, keyed by semantic speed. */
export const MOTION_DURATIONS_MS = {
  base: 250,
  fast: 150,
  slow: 300,
} as const

/** Standard easing curve shared across layout and morph transitions. */
export const MOTION_EASE_STANDARD = 'cubic-bezier(0.4, 0, 0.2, 1)'
